export default "__VITE_ASSET__D9egR036__"